import Layer from '@arcgis/core/layers/Layer';
import { GISService } from '../gisServicesTypes';
import { ensureLoadedLayerArray, LayerLoader } from './LayerLoader';

/**
 * Load a layer that's not otherwise special
 */
export const defaultLayerLoader: LayerLoader = {
  shouldUseLoader() {
    return true;
  },
  async load(service) {
    const properties = {
      id: service.gisLayerID,
      visible: service.auto_checked || false,

      // Currently all non-basemap layers get a 40% opacity. That may not be
      // the right choice! Feel free to doubt this line:
      opacity: 0.4,
      outFields: ['*'],
    };

    return loadWithProperties(service, properties);
  },
};

// This pattern gets reused with different properties for several layer types:
export async function loadWithProperties(
  service: GISService,
  properties: __esri.LayerFromArcGISServerUrlParams['properties'],
) {
  const apiKey = service.token;
  const url = service.gis_service_url;
  const requestUrl = apiKey ? url + `?token=${apiKey}` : url;
  const layer = await Layer.fromArcGISServerUrl({
    url: requestUrl,
    properties: {
      apiKey,
      ...properties,
    },
  });
  await layer.load();

  return ensureLoadedLayerArray(layer);
}
